export class ManuallyPlannedTime {
    hours: number;
    week: number;
    year: number;
    constructor(hours: number, week: number, year: number) {
        this.hours = hours;
        this.week = week;
        this.year = year;
    }
}